import React from 'react';
import './FactionGiantsDescription.css';
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {UNIT_TYPES} from "../../../../configs/units";
import {GIANTS_ADDITIONAL_SUPPLY_COST, GIANTS_UNIT_MAX_SIZE} from "../../../../configs/factions/giants";
import {UNIT_SIZE_FOR_SUPPLY_ON_BARRACKS, UNIT_SIZE_FOR_SUPPLY_ON_OTHER} from "../../../../constants/units";
import {COLORS_CONFIG, PLAYER_COLORS} from "../../../../configs/colors";

// Иконка великана — та же, что рисуется на поле у игроков без купленного
// фракционного скина. Перекрашивается маской (цвет — в CSS), поэтому это span
// с mask-image, а не img: PNG одноцветной заливке не поддается
const GIANT_UNIT_ICON_PATH = '/img/factions/unit_icons/unit_d20_giants_default.png';

const GiantUnitIcon = ({className}) => (
  <span
    className={`policy-description-icon-unit faction-giants-description_unit-icon ${className}`}
    style={{
      WebkitMaskImage: `url(${GIANT_UNIT_ICON_PATH})`,
      maskImage: `url(${GIANT_UNIT_ICON_PATH})`,
    }}
    role={'img'}
    aria-label={'Великан'}
    title={'Великан'}
  />
);

const FactionGiantsDescription = () => {
  const unitStart = <GiantUnitIcon className={'policy-description-icon-unit-margin-right'}/>;
  const unit = <GiantUnitIcon className={'policy-description-icon-unit-margin-right-left'}/>;

  const price = <CoinsStat
    text={UNIT_TYPES.D20.price}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left'}
  />;

  const unitSize = <img
    className={'policy-description-icon'}
    src={'/img/icons/unit size.png'}
    alt={'Размер отряда'}
    title={'Размер отряда'}
  />;

  const maxSizeValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={GIANTS_UNIT_MAX_SIZE}
    icon={unitSize}
  />;
  const supplyMiddle = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  const supply = <img
    className={'policy-description-icon'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  const cell = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/cell.png'}
    alt={'Ячейка'}
    title={'Ячейка'}
  />;

  const barracksMiddle = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;

  const sizeOnBarracksValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={`+${UNIT_SIZE_FOR_SUPPLY_ON_BARRACKS}`}
    icon={unitSize}
  />;
  const sizeOtherValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={`+${UNIT_SIZE_FOR_SUPPLY_ON_OTHER}`}
    icon={unitSize}
  />;

  const oneSupplyValueAndIcon = <DescriptionValueWithIcon
    className={'text-supply policy-description-icon-margin-right-left'}
    value={1}
    icon={supply}
  />;

  const additionalSupplyCostValueAndIcon = <DescriptionValueWithIcon
    className={'text-supply policy-description-icon-margin-right-left'}
    value={GIANTS_ADDITIONAL_SUPPLY_COST}
    icon={supply}
  />;

  const exclamation = <img
    className={'faction-description-icon faction-description-icon-margin-right'}
    src={'/img/icons/exclamation-mark.png'}
    alt={'Важное ограничение'}
    title={'Важное ограничение'}
  />;

  return (
    <>
      <div className="policy-description_line">
        {unitStart} <span style={{color: COLORS_CONFIG[PLAYER_COLORS.BROWN]}}>Великан</span> {price}: максимум {maxSizeValueAndIcon}.
      </div>
      <div className="policy-description_line">
        В
        <span className={'text-supply policy-description-icon-margin-right-left'}>
          фазе снабжения
        </span>
        может
      </div>
      <div className="policy-description_line">
        получать более {oneSupplyValueAndIcon}.
      </div>
      <div className="policy-description_line">
        За каждое {oneSupplyValueAndIcon} {sizeOnBarracksValueAndIcon} на {barracksMiddle}
      </div>
      <div className="policy-description_line">
        и {sizeOtherValueAndIcon} на любой другой {cell}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        {exclamation} Дополнительное {supplyMiddle} стоит {additionalSupplyCostValueAndIcon}.
      </div>
      <div className="policy-description_line">
        Можно нанимать только {unit}.
      </div>
    </>
  );
};

export default FactionGiantsDescription;
